import React, { Component } from 'react'
import { Row, Col, Badge, Button, Table,Form,InputGroup } from 'react-bootstrap';
import './StyleOrder.css';
import {onPrint} from '../../helpers/functionForLicense';

export default class OrderHealthCert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      Certificate: null,
      redirect : false
    } 
    this.handleDataInput = this.handleDataInput.bind(this)
  }

  // componentDidMount() {

  // }  
  // renderLicenseID(licenseID){
  //   return <a href="javascript:void(0)" onClick={()=>{onPrint(licenseID)}}> {licenseID}</a>
  // }
  // handleDescription(e){

  // }
  // handleCertificate(e){

  // }


  handleDataInput(e){
    console.log(e.target.value)
    console.log(e.target.id)
    this.setState({
      ...this.state,
      [e.target.id] : e.target.value
    },()=>{
      console.log(this.state)
    })
  }

  render() {
    let CheckWeightSheet = {}
    // console.log(CheckWeightSheet.description[this.props.desIndex])
    // console.log(CheckWeightSheet.checkWeightDescription[this.props.desIndex])
    let pointOn = 'online'
      // console.log(this.props.CertificateSheetDataOnline)
      // console.log(this.props.desIndex)
      // let handleData = this.props.CertificateSheetDataOnline.Certificate.description[this.props.desIndex]
      // CheckWeightSheet = this.props.CertificateSheetDataOnline.Certificate
      let handleData = {}
      // [,'(อังกฤษ)','1.2 ที่อยู่','1.3 โทรศัพท์']
      let arr = [
        [
          {
            'key' : 'nameTH',
            'display' : '1.1 ชื่อ (ไทย)',
          }
        ],
        [
          {
            'key' : 'nameEN',
            'display' : '(อังกฤษ)',
          }
        ],
        [
          {
            'key' : 'address',
            'display' : '1.2 ที่อยู่',
          }
        ],
        [
          {
            'key' : 'tel',
            'display' : '1.3 โทรศัพท์',
          },
          {
            'key' : 'telegram',
            'display' : '1.4 โทรสาร'
          }
        ],
        [
          {
            'key' : 'typeCertificate',
            'display' : 'อื่น ๆ (ให้ระบุ)'
          }
        ],
        [
          {
            'key' : 'licenseID',
            'display' : 'สำหรับการส่งออกข้าวตามใบอนุญาตเลขที่'
          }
        ],
        [
          {
            'key' : 'riceType',
            'display' : '2.1 ชนิดข้าว'
          }
        ],
        [
          {
            'key' : 'amount',
            'display' : '2.2 จำนวน',
          },
          {
            'key' : 'bagQuantity',
            'display' : 'ปริมาณ'
          }
        ],
        [
          {
            'key' : 'destination',
            'display' : '2.3 ประเทศปลายทาง'
          }
        ],
        [
          {
            'key' : 'vessel',
            'display' : 'เรือ ชื่อ'
          },
          {
            'key' : 'train',
            'display' : 'รถไฟ'
          },
          {
            'key' : 'car',
            'display' : 'รถบรรทุก'
          },
        ],
        [
          {
            'key' : 'airplane',
            'display' : 'เครื่องบิน'
          },
          {
            'key' : 'finishDate',
            'display' : 'บรรทุกเสร็จเมื่อวันที่'
          }
        ],
        [
          {
            'key' : 'goodLicense',
            'display' : '4.1 ใบกำกับสินค้าเลขที่'
          },
          {
            'key' : 'goodDate',
            'display' : 'ลงวันที่'
          }
        ],
        [
          {
            'key' : 'mateReceipts',
            'display' : '4.2 ใบตราส่งสินค้า B/L Mate Receipts อื่น ๆ '
          }
        ],
        [
          {
            'key' : 'fumigation',
            'display' : '4.3 ใบรับรองการรมยาของ'
          },
          {
            'key' : 'fumigationNo',
            'display' : 'เลขที่'
          },
          {
            'key' : 'fumigationDate',
            'display' : 'ลงวันที่'
          },
        ],
        [
          {
            'key' : 'etcDocument',
            'display' : '4.4 เอกสารอื่น ๆ ที่เกี่ยวข้อง '
          }
        ],
        [
          {
            'key' : 'externalRequire',
            'display' : 'อื่น ๆ'
          }
        ],
      ]
        
      return (
        <div>
    
        <div style={{width:'100%',alignContent:'center',textAlign:'center',fontSize:'22px'}}  >
          <p><b><u>คำขอหนังสือรับรองสำหรับการส่งออกข้าว</u></b></p>
        </div>
        {
          <div>
            <div className='TopSpace'>
              <Row>
                <Col align="center">
                  <Form className='ScaleDown'>

              {(()=>{
                return(arr.map((title)=>{
                  if(title.length > 1){
                    let divReturn = []
                    return(Object.values(title).map((data,idx)=>{
                      console.log(divReturn)
                      if(idx == title.length-1){
                        divReturn.push(<Form.Label column sm="2">
                                        {data['display']} 
                                      </Form.Label>)
                        divReturn.push(<Col sm="2">
                                        <Form.Control id={data['key']} onChange={this.handleDataInput}/>
                                      </Col>)
                        return (<Form.Group className="FormGroup" as={Row} controlId="Date">
                          {divReturn}
                          </Form.Group>
                          )
                      }else{
                        divReturn.push(<Form.Label column sm="2">
                                        {data['display']} 
                                      </Form.Label>)
                        divReturn.push(
                                      <Col sm="2">
                                        <Form.Control id={data['key']} onChange={this.handleDataInput}/>
                                      </Col>)
                      }
                    }))
                  }else{
                    return(
                      <Form.Group className="FormGroup" as={Row} controlId="Date">
                        <Form.Label column sm="2">
                                {title[0]['display']}  
                        </Form.Label>
                        <Col sm="8">
                          <Form.Control id={title[0]['key']} onChange={this.handleDataInput} />
                        </Col>      
                      </Form.Group>
                    )
                  }
                }))
              })()}
                  </Form>
                </Col>
              </Row>                    
              </div>
            </div>
          }
          </div>
      )
    
  }
}